'use strict';
(() => {
  // A footer section may be reloaded by the theme editor. Install listeners once.
  if (window.lushanInfoMounted) return;
  window.lushanInfoMounted = true;
  let host = null;
  let main = null;
  let activeSlug = null;
  const saved = new Map();

  function markActive(slug) {
    document.querySelectorAll('[data-info-link]').forEach(link => {
      if (link.dataset.infoLink === slug) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }

  function restore() {
    saved.forEach((state, node) => {
      node.hidden = state.hidden;
      if (state.ariaHidden === null) node.removeAttribute('aria-hidden');
      else node.setAttribute('aria-hidden', state.ariaHidden);
    });
    saved.clear();
    if (host) host.remove();
    host = null;
    activeSlug = null;
    markActive(null);
  }

  function render(force) {
    main = document.getElementById('MainContent');
    if (!main) return;
    const match = /^#info\/([a-z0-9-]+)$/.exec(window.location.hash);
    if (!match) {
      const wasActive = Boolean(host);
      restore();
      if (wasActive) {
        // Restore first so native page anchors become visible before scrolling.
        window.requestAnimationFrame(() => {
          let anchor = null;
          try { anchor = document.getElementById(decodeURIComponent(window.location.hash.slice(1))); } catch (_) { /* malformed hash is not an anchor */ }
          if (anchor) anchor.scrollIntoView();
          else main.focus({ preventScroll: true });
        });
      }
      return;
    }
    const slug = match[1];
    if (host && activeSlug === slug && !force) return;
    const template = Array.from(document.querySelectorAll('template[data-lushan-info-template]'))
      .find(item => item.dataset.lushanInfoTemplate === slug);
    if (template && template.dataset.nativePage) {
      window.location.assign(template.dataset.nativePage);
      return;
    }
    if (!host) {
      host = document.createElement('section');
      host.className = 'wrap lushan-info-view';
      host.setAttribute('aria-label', 'Informations pratiques');
      main.appendChild(host);
    }
    Array.from(main.children).forEach(node => {
      if (node === host) return;
      if (!saved.has(node)) saved.set(node, { hidden: node.hidden, ariaHidden: node.getAttribute('aria-hidden') });
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
    });
    host.replaceChildren();
    if (template) host.appendChild(template.content.cloneNode(true));
    else {
      const article = document.createElement('article');
      article.className = 'service-page';
      const heading = document.createElement('h1');
      heading.textContent = 'Page introuvable';
      heading.setAttribute('tabindex', '-1');
      const paragraph = document.createElement('p');
      paragraph.textContent = 'Cette page d’information n’est pas disponible.';
      article.appendChild(heading);
      article.appendChild(paragraph);
      host.appendChild(article);
    }
    activeSlug = slug;
    markActive(slug);
    const heading = host.querySelector('h1');
    if (heading) heading.focus({ preventScroll: true });
    host.scrollIntoView({ block: 'start' });
  }

  window.addEventListener('hashchange', () => render(false));
  window.addEventListener('popstate', () => render(false));
  document.addEventListener('shopify:section:load', () => render(true));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => render(false), { once: true });
  else render(false);
})();
